import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/types/graph';
import { useResetQuestionnaire } from '@/hooks/useResetQuestionnaire';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/components/ui/dialog';
import { isKioskOnboarding } from '@/util/kiosk';

/**
 * Shown once the server rejected a save because the questionnaire was saved
 * more recently from another device (ALDO-2759). Saving stops on this device
 * so it can't overwrite those answers. The borne has nothing to keep and
 * returns straight to its check-in screen.
 */
export const QuestionnaireConflictDialog = () => {
  const resetQuestionnaire = useResetQuestionnaire();
  const conflict = useSelector(
    (state: RootState) => state.questionnaireConflict,
  );
  const isKiosk = useSelector((state: RootState) =>
    isKioskOnboarding(state.questionnaire.config?.patientOnboarding),
  );

  useEffect(() => {
    if (conflict && isKiosk) resetQuestionnaire();
  }, [conflict, isKiosk, resetQuestionnaire]);

  if (!conflict || isKiosk) return null;

  return (
    <Dialog open>
      <DialogContent className="nsm:w-[452px]">
        <div className="flex flex-col items-center gap-4 px-5 py-4 text-center nsm:px-8">
          <DialogTitle className="text-xl font-medium">
            Questionnaire poursuivi sur un autre appareil
          </DialogTitle>
          <DialogDescription className="text-base font-light text-foreground">
            Vos réponses ont été enregistrées depuis un autre appareil. Pour ne
            pas les écraser, ce questionnaire ne peut plus être modifié ici
          </DialogDescription>
          <Button
            variant="ctaPrimary"
            size="lg"
            onClick={() => resetQuestionnaire()}
            className="mt-2"
          >
            Fermer
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
